import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const useMonthsOptions = () => {
  const { t } = useTranslation('months');

  return useMemo(
    () => [
      {
        label: t('january'),
        value: '01',
      },
      {
        label: t('february'),
        value: '02',
      },
      {
        label: t('march'),
        value: '03',
      },
      {
        label: t('april'),
        value: '04',
      },
      {
        label: t('may'),
        value: '05',
      },
      {
        label: t('june'),
        value: '06',
      },
      {
        label: t('july'),
        value: '07',
      },
      {
        label: t('august'),
        value: '08',
      },
      {
        label: t('september'),
        value: '09',
      },
      {
        label: t('october'),
        value: '10',
      },
      {
        label: t('november'),
        value: '11',
      },
      {
        label: t('december'),
        value: '12',
      },
    ],
    [t],
  );
};

export default useMonthsOptions;
